import React from "react";
import { motion } from "framer-motion";
import { PILOT } from "../data/entrepminds";
import { Sparkles } from "lucide-react";

const CaseStudy = () => {
  return (
    <section id="case-study" data-testid="case-study-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <div className="section-eyebrow mb-4">Pilot Client</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] max-w-3xl">
            <span className="gold-text">GrowthOS™</span> in production.
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-8 items-stretch">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7 relative rounded-2xl overflow-hidden border border-[#d4af37]/45 min-h-[420px]"
          >
            <img
              src={PILOT.image}
              alt={PILOT.name}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#faf7ee] via-[#faf7ee]/30 to-transparent" />
            <div className="relative h-full p-8 md:p-10 flex flex-col justify-end">
              <div className="inline-flex items-center gap-2 font-mono-em text-[10px] tracking-[0.25em] uppercase text-[#8a6a10] mb-3">
                <Sparkles size={12} /> Beauty & Education
              </div>
              <h3 className="font-display text-3xl md:text-4xl max-w-lg">
                {PILOT.name}
              </h3>
              <p className="mt-2 text-[#6b6356] text-sm">{PILOT.subtitle}</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-5 em-card p-8 md:p-10 flex flex-col"
          >
            <div className="font-mono-em text-xs tracking-[0.25em] uppercase text-[#8a6a10] mb-4">
              What we built
            </div>
            <h4 className="font-display text-2xl mb-6">
              An end-to-end growth stack — brand to automation.
            </h4>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-[#3f3a30]">
              {PILOT.deliverables.map((d) => (
                <li key={d} className="flex items-center gap-2 border-l border-[#d4af37]/45 pl-3 py-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#d4af37]" />
                  {d}
                </li>
              ))}
            </ul>
            <div className="gold-divider my-8" />
            <p className="text-sm text-[#6b6356] leading-relaxed">
              From inquiry to enrollment to revenue — every touchpoint is connected,
              automated and measurable on a single executive dashboard.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudy;
